import {Grid} from '@primer/react-brand'

import type {FlexSuiteDefaultHeroProps} from './types'
import {HeroContent} from './HeroContent'

/**
 * Default hero (no variant specified): text-only gridline
 */
export function FlexSuiteHeroDefault({fields}: {fields: FlexSuiteDefaultHeroProps}) {
  return (
    <Grid data-testid="hero-default">
      <Grid.Column>
        <HeroContent {...fields} />
      </Grid.Column>
    </Grid>
  )
}
